export default "__VITE_ASSET__CrTj40Gz__"